<template>

    <div class="h-full text-center flex flex-col justify-around text-sm flex-grow ">

        <div class="w-full px-3">

            <a href="#" v-if="agents_can != 'send' && agents_can != 'none' && missing_essential_data"
                title="Request a recording" class="py-2 text-left flex items-center gap-x-3 group opacity-50"
                @click.prevent="ask_for_a_recording()">
                <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="group-hover:text-birdie-blue">
                    Request a recording
                </div>
            </a>
            <a href="#" v-else-if="agents_can != 'send' && agents_can != 'none' && !missing_essential_data"
                title="Request a recording" class="py-2 text-left flex items-center gap-x-3  group"
                @click.prevent="ask_for_a_recording()">
                <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="group-hover:text-birdie-blue" v-if="!ask_recording_loading">
                    Request a recording
                </div>
                <div class="" v-else>
                    <spinner class="mx-auto h-5 w-5 text-gray-500"></spinner>
                </div>
            </a>
            <a v-else disabled title="Request a recording"
                class="py-2 text-left flex items-center gap-x-3  opacity-50 cursor-default">
                <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="">
                    Request a recording (disabled)
                </div>
            </a>

            <a v-if="agents_can != 'request' && agents_can != 'none'" :href="send_recording_url"
                title="Send a recording" @click="send_a_recording_clicked()"
                class="py-2 text-left flex items-center gap-x-3  group" target="_blank">
                <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="group-hover:text-birdie-blue">
                    Send a recording
                </div>
            </a>
            <a v-else disabled title="Send a recording"
                class="py-2 text-left flex items-center gap-x-3  opacity-50 cursor-default">
                <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="">
                    Send a recording (disabled)
                </div>
            </a>

            <a v-if="has_cobrowsing" :href="cobrowsingLink" title="Start CoBrowsing"
                class="py-2 text-left flex items-center gap-x-3  group" target="_blank">
                <img src="/img/cobrowsing.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="group-hover:text-birdie-blue">
                    Start CoBrowsing
                </div>
            </a>
            <a v-else-if="false" href="#" @click.prevent.stop title="CoBrowsing"
                class="py-2 text-left flex items-center gap-x-3 opacity-50 cursor-default">
                <img src="/img/cobrowsing.svg" alt="Screen Recording" class="w-4 h-4" />
                <div class="">
                    CoBrowsing (disabled)
                </div>
            </a>

        </div>


        <div class="mt-4 px-3 text-left flex flex-shrink text-gray-600 ">Get help at
            <a class="no-underline hover:underline ml-1" target="_blank"
                href="https://docs.birdie.so/birdie-docs/helpdesk/helpscout/screen-recording"
                title="Go to Birdie documentation">docs.birdie.so</a>

        </div>


    </div>

</template>





<script>

//import { debounce } from "debounce";
import Spinner from '@/Components/UI/Spinner'

//import '@spartez/vue-atlaskit/dist/bundle.css';
//import Button from '@atlaskit/button';
//import { Button } from '@spartez/vue-atlaskit';



export default {

    name: "IntegrationHelpscout",

    props: [
        'agents_can',
        'appId',
        'companyId',
        'has_cobrowsing',
        'has_screenrecording',
        'context',
        'team_slugname',
        'team_slug',
        'secure_code',
        'utf8_to_b64',
        'getContext',
        'missing_essential_data',
        'is_chat',
    ],

    // 4 locations: agent-edit, customer-create, customer-edit, customer-sidebar

    components: {
        Spinner, //Button
    },

    data() {
        return {

            ask_recording_loading: false,
            send_recording_loading: false,

            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),


            tinyurl: "",
            cobrowsingLink: "",

        }
    },

    created: function () {

    },

    beforeUnmount() {

    },

    mounted: function () {

    },

    methods: {

        send_a_recording_clicked: function () {
            this.$emit('setNotification', 'Once your recording is complete, return here to paste your video link into the conversation.', 'MESSAGE')
        },

        ask_for_a_recording: function () {

            if (this.ask_recording_loading) {
                return;
            }

            if (this.missing_essential_data) {
                this.$emit('setNotification', 'Unable to access HelpScout data. To request a recording, reply to an existing conversation.', 'ERROR')
                return
            }

            const the_link_base = this.$page.props.app_url.replace(this.$page.props.app_url, "https://" + this.team_slugname + "." + this.domain);

            if (this.tinyurl != "") {
                const short_link = the_link_base + "/rec/" + this.tinyurl
                this.$emit('setClipboard', short_link, 'Request Link copied! You can now paste it into your message.')
                return
            }


            var the_link = the_link_base + "/recorder";

            // should not happen anymore
            // if (!this.context.customer || !this.context.conversation) {
            //     this.$emit('setNotification', 'We can’t retrieve conversation data, please open a new message', 'ERROR')
            //     return
            // }

            const userName = this.context.user.firstName + ' ' + this.context.user.lastName
            const customerName = this.context.customer.firstName + ' ' + this.context.customer.lastName
            const data = {
                is_chat: this.is_chat,
                company_id: this.context.company.id,
                mailbox_id: this.context.mailbox.id,
                mailbox_email: this.context.mailbox.email,
                user_id: this.context.user.id,
                user_email: this.context.user.email,
                user_name: userName.trim(),
                conversation_id: null,
                conversation_number: null,
                customer_id: this.context.customer.id,
                customer_name: customerName.trim(),
                customer_email: this.context.customer.emails[0].value,
            }
            if (this.context.conversation) {
                data.conversation_id = this.context.conversation.id
                data.conversation_number = this.context.conversation.number
            }
            const hep = this.secure_code(this.utf8_to_b64(JSON.stringify(data)))
            the_link += '?hep=' + hep



            if (this.$page.props.app_url.indexOf(".test") >= 0 || this.$page.props.app_url.indexOf("ngrok") >= 0) {
                the_link += "&team=" + this.team_slugname; // DEBUG

                console.log("data", data)
                console.log("this.$page.props.app_url", this.$page.props.app_url)

            }

            this.saveTinyAndSend(the_link)
        },

        saveTinyAndSend: function (the_link) {
            this.ask_recording_loading = true
            let url = this.$page.props.app_url + '/tinyurl/save';
            var params = {
                data: the_link,
                team_slug: this.team_slug
            }
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        if (response.data.tinyurl) {
                            this.tinyurl = response.data.tinyurl
                            this.ask_recording_loading = false
                            this.ask_for_a_recording()
                        }
                    }
                })
                .catch(e => {
                    console.error(e)
                    this.ask_recording_loading = false
                    this.$emit('setNotification', 'An error occured, cannot get recording link', 'ERROR')
                });
        },

    },

    computed: {

        cobrowsingLink: function () {
            var query = ""
            if (this.context.customer) {
                const customerName = this.context.customer.firstName + ' ' + this.context.customer.lastName
                if (this.context.customer.emails.length > 0) {
                    query = this.context.customer.emails[0].value
                } else if (customerName.trim() != "") {
                    query = customerName.trim()
                } else if (this.context.customer.id) {
                    query = this.context.customer.id
                }
            }
            if (query == "") {
                return this.$page.props.app_url + "/cobrowsing"
            }
            return this.$page.props.app_url + '/cobrowsing/helpscout?q=' + encodeURI(query)
        },

        send_recording_url: function () {


            const the_link_base = this.$page.props.app_url.replace(this.$page.props.app_url, "https://" + this.team_slugname + "." + this.domain)

            var the_link = the_link_base + "/recorder"

            const userName = this.context.user.firstName + ' ' + this.context.user.lastName
            var data = {
                company_id: this.context.company.id,
                mailbox_id: this.context.mailbox.id,
                mailbox_email: this.context.mailbox.email,
                user_id: this.context.user.id,
                user_email: this.context.user.email,
                user_name: userName.trim(),
                // conversation_id: this.context.conversation.id,
                // conversation_number: this.context.company.number,
                // customer_id: this.context.customer.id,
                // customer_name: customerName.trim(),
                // customer_email: this.context.customer.emails[0].value,
            }

            if (this.context.customer && this.context.conversation) {
                const customerName = this.context.customer.firstName + ' ' + this.context.customer.lastName
                data.conversation_id = this.context.conversation.id
                data.conversation_number = this.context.company.number
                data.customer_id = this.context.customer.id
                data.customer_name = customerName.trim()
                data.customer_email = this.context.customer.emails[0].value

            }

            const hid = this.secure_code(this.utf8_to_b64(JSON.stringify(data)))
            the_link += '?hid=' + hid
            if (this.$page.props.app_url.indexOf(".test") >= 0 || this.$page.props.app_url.indexOf("ngrok") >= 0) {
                the_link += "&team=" + this.team_slugname; // DEBUG
            }

            return the_link
        }
    }

}

</script>

<style scoped scss></style>
